<template>
    <section class="find-my-car" id="findMyCar">
        <div class="valuation-box valuation-box--narrow form-inline">
            <div class="valuation-box-inner">
                <div class="valuation-box-header">
                    <h2><strong>Free instant</strong> vehicle valuation</h2>
                </div>
                <form @submit.prevent="submit" ref="form" method="post" class="valuation-box-fields">
                    <div class="valuation-box-field">
                        <label class="valuation-box-label" for="valuation_reg_no">Enter reg</label>
                        <div class="valuation-box-reg">
                            <input
                                class="form-control valuation-box-input valuation-box-input--reg"
                                type="TEXT"
                                name="reg_no"
                                id="valuation_reg_no"
                                placeholder="Registration"
                                data-validate="input"
                                data-validate-message="Please enter your vehicle registration"
                                data-error-target="valuationRegError"
                                v-model="vehicleData.registration"
                            />
                            <img class="valuation-box-reg-icon" src="/images/valuations/reg-icon.png" alt="GB" />
                        </div>
                        <div class="valuation-box-error" id="valuationRegError"></div>
                    </div>
                    <div class="valuation-box-field">
                        <label class="valuation-box-label" for="valuation_mileage">Enter mileage</label>
                        <input
                            class="form-control valuation-box-input valuation-box-input--mileage"
                            type="text"
                            name="mileage"
                            id="valuation_mileage"
                            placeholder="Mileage"
                            data-validate="input"
                            data-validate-message="Please enter your vehicle mileage"
                            v-model="vehicleData.mileage"
                        />
                    </div>
                    <div class="valuation-box-field valuation-box-field--button">
                        <button type="submit" class="btn btn-valuation btn-full-width-xs btn-full-width valuation-box-btn" >Value My Car</button>
                    </div>
                </form>
                <div class="valuation-box-copy">
                    <p class="valuation-box-text valuation-box-text--big">
                        Enter your Registration Number to find your vehicle's details or <a class="valuation-widget-manual-lookup"  @click="manualVehicleSearch">click here</a> to search for your vehicle manually.
                    </p>
                    <p class="valuation-box-text valuation-box-text--small">
                        This is an estimated valuation of your vehicle based on the information you have provided. It is not an offer to purchase your vehicle. The estimated valuation may change and the condition of your vehicle will be
                        inspected by the purchaser. You should ensure that you have taken into account any other costs connected with the disposal of your current vehicle before committing to a deposit for any new vehicle under a finance
                        agreement.
                    </p>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import { mapActions, mapState } from "vuex";
import ContactFormValidator from '../../../validation/ContactFormValidator';

export default {
    data() {
        return {
            validator: null,
            vehicleData:{
                registration: "",
                mileage: "",
            },
        };
    },

    mounted() {
        this.validator = new ContactFormValidator({
            element: this.$refs['form'],
            vueForm: true,
            redesign: true,
        });
    },

    computed: {
        ...mapState("ValuationTool", ["enquiryMaxValuationID", "isDealer"]),
    },

    methods: {
        ...mapActions('ValuationTool', ['findMyCar', 'manualVehicleSearch']),
        async submit() {
            if (!await this.validator.isValid()) {
                this.validator.scrollToFirstError();
                return;
            }

            this.validator.preventInput();

            this.findMyCar(this.vehicleData)
                .then(response => {
                    this.validator.successResponse();
                    if (this.enquiryMaxValuationID != null || this.isDealer  ) {
                        this.$store.dispatch('ValuationTool/getDealerSpecificValuation')
                    } else {
                        this.$store.commit('ValuationTool/setStep', 2);
                    }
                })
                .catch(error => {
                    console.error(error);
                    this.validator.errorResponse(error);
                })
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/valuation-tool/components/Steps/FindMyCar.vue